import { BarthelScoreScreen } from "app/screens/residents/show/BarthelScoreScreen";

export default function BarthelScorePage() {
  return <BarthelScoreScreen />;
}
